import ExcellentExport from 'excellentexport';

require('./stat-menu.component.scss');

class StatMenuController {
  constructor(CurrentFilterService, RouterService, PermissionService) {
    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  get filter() {
    // return this.CurrentFilterService.filter;
    return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
  }

  setMode(mode) {
    if (this.isFilterEdit && this.filterData) this.filterData.filter.mode = mode;
    else this.router.mode = mode;
  }

  get isFilterEdit() {
    return this.router.isFilterEditModal;
  }

  generateReport(url) {
    if (this.isFilterEdit && this.filterData) {
      this.setMode('reports');
      this.filterData.filter.url = url;
    } else this.router.generateReport(url);
  }

  download($event) {
    ExcellentExport.excel($event.currentTarget, 'datatable');
    return true;
  }
}

export const StatMenuComponent = {
  template: require('./stat-menu.component.html'),
  bindings: {
    filterData: '<',
  },
  controller: StatMenuController,
};



// WEBPACK FOOTER //
// ./src/stat/stat-menu.component.js